// utils
import { ENV, MAIN_ENV } from '../../constants/global.constants';
// redux
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

// Log para debugging de la construcción del baseUrl
const country = MAIN_ENV.COUNTRY;
const apiUrl = ENV[country]?.REACT_APP_HABI_API_URL_V2;
const basePath = ENV[country]?.REACT_APP_BUSINESS_GLOBAL_API_BASE_PATH;
const baseUrl = `${apiUrl}${basePath}`;

export const brokersBusinessApi = createApi({
  reducerPath: 'brokersBusinessApi',
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl,
      headers: {
        'x-api-key': ENV[MAIN_ENV.COUNTRY].REACT_APP_BUSINESS_API_KEY,
        'Content-Type': 'application/json',
      },
    }),
    {
      maxRetries: 1,
    }
  ),
  endpoints: (builder) => ({
    getFeeCalculator: builder.query({
      query: ({ nid, offer_value, force_non_traditional }) => {
        const params = new URLSearchParams({
          country: country,
          nid: nid?.toString(),
          offer_value: offer_value?.toString(),
        });

        if (force_non_traditional) {
          params.append('force_non_traditional', 'true');
        }

        return {
          url: `fee-calculator?${params.toString()}`,
        };
      },
    }),
  }),
});

export const { useGetFeeCalculatorQuery } = brokersBusinessApi;
